module.exports = __webpack_public_path__ + "img/cat_rendah.ff04d5ec.png";